// extracted by mini-css-extract-plugin
module.exports = {"logo":"hotel_logo_logo__vXJk-","logoContainer":"hotel_logo_logoContainer__XQ_O_"};